import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <h1 className="text-4xl font-bold mb-3">WuDaoDev Studio</h1>
      <h2 className="text-xl text-gray-300 mb-8">五维软件生产线驾驶舱</h2>

      <div className="bg-gray-800 rounded-lg p-6 mb-6">
        <div className="text-lg mb-3">当前入口已切换为驾驶舱首页</div>
        <div className="text-gray-400 leading-7">
          这里不再是普通项目列表页，而是生产线总控台。
          <br />
          你现在可以进入：
          <br />
          - AI助手
          <br />
          - 双模型评审
          <br />
          - 验收检测
          <br />
          - 五维解构
          <br />
          - 服务控制
          <br />
          - 部署打包
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <button
          onClick={() => navigate('/audit')}
          className="bg-purple-600 hover:bg-purple-700 rounded px-4 py-3"
        >
          审计回溯
        </button>

        <button
          onClick={() => navigate('/params')}
          className="bg-blue-600 hover:bg-blue-700 rounded px-4 py-3"
        >
          系统参数
        </button>

        <button
          onClick={() => navigate('/memory')}
          className="bg-green-600 hover:bg-green-700 rounded px-4 py-3"
        >
          记忆库
        </button>

        <button
          onClick={() => navigate('/project/demo')}
          className="bg-orange-600 hover:bg-orange-700 rounded px-4 py-3"
        >
          打开工作区
        </button>

        <button
          onClick={() => navigate('/project/demo')}
          className="bg-cyan-600 hover:bg-cyan-700 rounded px-4 py-3"
        >
          驾驶舱工作区
        </button>

        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 hover:bg-gray-700 rounded px-4 py-3"
        >
          刷新页面
        </button>
      </div>
    </div>
  );
}
